import React, { Component } from "react";

import { Metric } from "./../Utils/Utils.js";
import Heading from "./../Elements/Heading";

class SubscribersSummary extends Component {
  render() {
    const { data } = this.props;

    return (
      <div className="row d-flex align-items-start">
        <div className="col-6 col-md-3 mb-3 mb-md-0">
          <Heading size={6} className={"mb-1"}>
            Free Trial Starts Yesterday
          </Heading>
          <Metric {...data.free_trial_starts} size={"lg"} />
        </div>

        <div className="col-6 col-md-3 mb-3 mb-md-0">
          <Heading size={6} className={"mb-1"}>
            Conversions To Paid Yesterday
          </Heading>
          <Metric {...data.converted_to_paid} size={"lg"} />
        </div>

        <div className="col-6 col-md-3">
          <Heading size={6} className={"mb-1"}>
            Total Paying Subs All Platforms <br /> (As of Yesterday)
          </Heading>
          <Metric {...data.total_paying_subs} size={"lg"} />
        </div>

        <div className="col-6 col-md-3">
          <Heading size={6} className={"mb-1"}>
            Total Active Free Trials <br /> (As of Yesterday)
          </Heading>
          <Metric {...data.total_active_free_trials} size={"lg"} />
        </div>

        {/* <div className="col-6 col-md-3">
          <Heading size={6} className={'mb-1'} >
            Cancels
          </Heading>
          <Metric {...data.cancels} size={'md'} />
        </div> */}
      </div>
    );
  }
}

export default SubscribersSummary;
